import {
	OnInit,
	Directive,
	ViewContainerRef,
	TemplateRef,
	Input
} from '@angular/core';
import { AuthService } from '../auth-service';
import { User } from '../../api/domain-impl';

@Directive({
    selector: '[ifHasRole]',
    standalone: false
})
export class IfHasRoleDirective implements OnInit {
	private roles: string[];
	private user: User;

	constructor(
		private templateRef: TemplateRef<any>,
		private viewContainer: ViewContainerRef,
		private authService: AuthService
	) {}

	ngOnInit() {
		this.authService.currentUser.subscribe((u) => {
			this.user = u;
			this.evaluate();
		});
	}

	evaluate() {
		if (this.user && this.roles) {
			for (let i = 0; i < this.roles.length; i++) {
				if (this.user.hasRole(this.roles[i])) {
					this.viewContainer.createEmbeddedView(this.templateRef);
					return;
				}
			}
		}
		this.viewContainer.clear();
	}

	@Input()
	set ifHasRole(roles: string[] | string) {
		if (roles) {
			if (typeof roles == 'string') roles = [roles];
			this.roles = roles;
		}
		this.evaluate();
	}
}
